import WidgetHostConfigModelBase from '../_generated/modelBases/widget-host-config-model-base';

export default class WidgetHostConfigModel extends WidgetHostConfigModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
